export function getCanvasLogicalSize(canvas: HTMLCanvasElement): { width: number; height: number } {
    const rect = canvas.getBoundingClientRect();
    const devicePixelRatio = window.devicePixelRatio || 1;
    return {
        width: rect.width || canvas.width / devicePixelRatio,
        height: rect.height || canvas.height / devicePixelRatio,
    };
}
